import ProductCard from "./product-card/product-card";
import { componentStyles } from "./product-cards.scss";

function ProductCards({
  products,
  setSelectedProductColors,
  handleCardClick,
  translate,
  departmentsHeight,
  distanceOfBottomPartFromTop,
  cardBackSidePaddingTop,
  logoWidth,
  departmentsTitle,
  cardWidth
}) {
  return (
    <div className="home-page-product-cards">
      {products?.map((product, index) => (
        <ProductCard
          departmentsTitle={departmentsTitle}
          product={product}
          index={index}
          cardWidth={cardWidth}
          setSelectedProductColors={setSelectedProductColors}
          handleCardClick={handleCardClick}
          translate={translate}
          departmentsHeight={departmentsHeight}
          distanceOfBottomPartFromTop={distanceOfBottomPartFromTop}
          cardBackSidePaddingTop={cardBackSidePaddingTop}
          logoWidth={logoWidth}
        />
      ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
}

export default ProductCards;
